import { render, staticRenderFns } from "./newsletter-box.vue?vue&type=template&id=d0527f96&scoped=true&"
import script from "./newsletter-box.vue?vue&type=script&lang=js&"
export * from "./newsletter-box.vue?vue&type=script&lang=js&"
import style0 from "./newsletter-box.vue?vue&type=style&index=0&id=d0527f96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0527f96",
  null
  
)

export default component.exports